import {combineReducers} from "redux";
import medigroupRootViewModel from "./medigroup/index";
import dataOverviewViewModel from "./dataoverview/dataOverviewViewModel";
import basicSettingViewModel from "./setting/basicSettingViewModel";
import docStateStatViewModel from "./stat/docStateStatViewModel";
import monthChangeStatViewModel from "./stat/monthChangeStatViewModel";
import docTeamStatViewModel from "./stat/docTeamStatViewModel";
import queryDocWorkStatusViewModel from "./stat/queryDocWorkStatusViewModel";
import dataDetailDrawerViewModel from "./dataoverview/dataDetailDrawerViewModel";


const rootViewModel = combineReducers({
    medigroup: medigroupRootViewModel,
    dataDetailDrawerViewModel,
    dataOverviewViewModel,
    basicSettingViewModel,
    docStateStatViewModel,
    monthChangeStatViewModel,
    docTeamStatViewModel,
    queryDocWorkStatusViewModel,
});

export default rootViewModel;
